import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const HERO_IMAGE = '/img/site_imgs/main-bg.jpg';

function scrollToId(id) {
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' });
  }
}

function Hero(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <section id="home" className="lf-hero-wrap">
      <img src={HERO_IMAGE} alt="A bride arranging floral aisle decor beside a flower-adorned mantel and gold chiavari chairs." loading="eager" decoding="async" />
      <div className="lf-editorial lf-hero-content">
        <div className="lf-reveal" style={{ maxWidth: '42rem' }}>
          <p className="lf-eyebrow">{floral.hero.eyebrow[language]}</p>
          <h1 className="lf-hero-title lf-display">{floral.hero.title[language]}</h1>
          <p className="lf-hero-desc">{floral.hero.description[language]}</p>
          <div className="d-flex flex-wrap mt-4" style={{ gap: '0.75rem' }}>
            <a
              className="lf-btn-primary lf-hero-btn-light"
              onClick={() => {
                scrollToId('portfolio');
              }}
            >
              {floral.hero.viewWork[language]}
            </a>
            <a
              className="lf-btn-secondary lf-hero-btn-outline"
              onClick={() => {
                scrollToId('contact');
              }}
            >
              {floral.hero.inquireNow[language]}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export { Hero };
